import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentsSidebarFilterItemCheckbox from './VeltCommentsSidebarFilterItemCheckbox/VeltCommentsSidebarFilterItemCheckbox';
import VeltCommentsSidebarFilterItemCount from './VeltCommentsSidebarFilterItemCount/VeltCommentsSidebarFilterItemCount';
import VeltCommentsSidebarFilterItemName from './VeltCommentsSidebarFilterItemName/VeltCommentsSidebarFilterItemName';
var VeltCommentsSidebarFilterItem = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-item-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterItem.Checkbox = VeltCommentsSidebarFilterItemCheckbox;
VeltCommentsSidebarFilterItem.Count = VeltCommentsSidebarFilterItemCount;
VeltCommentsSidebarFilterItem.Name = VeltCommentsSidebarFilterItemName;
export default VeltCommentsSidebarFilterItem;
